var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 5.14287V6.00001C26 6.11368 25.9543 6.22268 25.8731 6.30306C25.7918 6.38343 25.6816 6.42858 25.5667 6.42858H24.2667V7.07144C24.2667 7.42646 23.9756 7.7143 23.6167 7.7143H2.38333C2.02437 7.7143 1.73333 7.42646 1.73333 7.07144V6.42858H0.433333C0.318406 6.42858 0.208186 6.38343 0.12692 6.30306C0.0456546 6.22268 0 6.11368 0 6.00001V5.14287C6.19744e-07 5.05808 0.0254301 4.9752 0.0730709 4.90471C0.120712 4.83422 0.188423 4.77929 0.267637 4.74687L12.8343 0.032586C12.9404 -0.0108619 13.0596 -0.0108619 13.1657 0.032586L25.7324 4.74687C25.8116 4.77929 25.8793 4.83422 25.9269 4.90471C25.9746 4.9752 26 5.05808 26 5.14287ZM24.7 21.4286H1.3C0.582021 21.4286 0 22.0042 0 22.7143V23.5714C0 23.6851 0.0456546 23.7941 0.12692 23.8745C0.208186 23.9548 0.318406 24 0.433333 24H25.5667C25.6816 24 25.7918 23.9548 25.8731 23.8745C25.9543 23.7941 26 23.6851 26 23.5714V22.7143C26 22.0042 25.418 21.4286 24.7 21.4286ZM4.33333 8.57144V18.8571H2.38333C2.02437 18.8571 1.73333 19.145 1.73333 19.5V20.5714H24.2667V19.5C24.2667 19.145 23.9756 18.8571 23.6167 18.8571H21.6667V8.57144H18.2V18.8571H14.7333V8.57144H11.2667V18.8571H7.8V8.57144H4.33333Z",
    fill: "#0D2645",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.ee26fb097699c5ef7378c53458539d2d.svg";
export { ForwardRef as ReactComponent };